var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActiveFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4166 6.25H4.41663C3.72627 6.25 3.16663 6.80965 3.16663 7.5C3.16663 8.19035 3.72627 8.75 4.41663 8.75H14.4166C15.107 8.75 15.6666 8.19035 15.6666 7.5C15.6666 6.80965 15.107 6.25 14.4166 6.25ZM10.6666 12.5H8.16663C7.47627 12.5 6.91663 13.0596 6.91663 13.75C6.91663 14.4404 7.47627 15 8.16663 15H10.6666C11.357 15 11.9166 14.4404 11.9166 13.75C11.9166 13.0596 11.357 12.5 10.6666 12.5ZM16.9166 0H1.91663C1.22627 0 0.666626 0.559648 0.666626 1.25C0.666626 1.94035 1.22627 2.5 1.91663 2.5H16.9166C17.607 2.5 18.1666 1.94035 18.1666 1.25C18.1666 0.559648 17.607 0 16.9166 0Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFilter);
export default __webpack_public_path__ + "static/media/ActiveFilter.0990707513e7ff99f494597a5636484e.svg";
export { ForwardRef as ReactComponent };